<template>
    <div class="agreement_box no-trans" v-loading="loading">
        <el-dialog title="隐私及条款" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <div class="dialog_box">
                <div class="titles1" v-if="texts=='site_xieyi'">隐私及条款</div>
                <div class="titles1" v-if="texts=='customer_agreement'">客户协议</div>
                <div class="titles1" v-if="texts=='personal_rule'">第三方个人信息处理规则</div>
                <div class="titles2">前言</div>
                <div class="consts" v-html="site_xieyi" v-if="texts=='site_xieyi'">
                </div>
               
                <div class="consts" v-html="customer_agreement" v-if="texts=='customer_agreement'">
                </div>
                 <div class="consts" v-html="personal_rule" v-if="texts=='personal_rule'">
                </div>
                <div class="btn_flex">
                    <div class="bnts" @click="handle_end">同意条款并继续</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            dialogVisible:false,//显示隐藏
            site_xieyi:'',
            customer_agreement:'',
            personal_rule:'',
            texts:'site_xieyi',
           
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        this.get_setting()
    },
    methods: {
        handleClose(){
            this.dialogVisible=false
        },
        handle_end(){
            this.dialogVisible=false
            this.$emit('handle_end')
        },
        handle_open(text){
            this.dialogVisible=true
            if(text){
                this.texts=text
            }else{
                this.texts='site_xieyi'
            }

        },
        get_setting(){
            this.$api("setting", {
			 
			}, "get").then((res) => {
                 this.site_xieyi=res.data.site_xieyi
                 this.customer_agreement=res.data.customer_agreement
                 this.personal_rule=res.data.personal_rule
               
            });
        },



    },

}
</script>
<style scoped lang="less">
.agreement_box {
    /deep/.el-dialog__wrapper{
        .el-dialog{
            width: 960px;
            .el-dialog__header{
                background: #F7F7F7;
            }
            .el-dialog__body{
                .dialog_box{
                    .titles1{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        text-align: center;
                    }
                    .titles2{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        text-align: center;
                        padding-top: 31px;
                    }
                    .consts{
                        padding-top: 24px;
                        height: 500px;
                        overflow-y: scroll;
                        padding: 0 30px;
                        line-height: 25px;
                    }
                    .btn_flex{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .bnts{
                            width: 280px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            line-height: 40px;
                            text-align: center;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;

                        }
                    }
                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .agreement_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .titles1 {
        font-size: 18px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .titles2 {
        font-size: 14px;
        padding-top: 16px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .consts {
        padding-top: 16px;
        min-height: 0;
        height: auto;
        padding: 0 16px;
        line-height: 25px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .agreement_box.no-trans /deep/ .el-dialog__wrapper .el-dialog .el-dialog__body .dialog_box .btn_flex .bnts {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        line-height: 40px;
        font-size: 14px;
    }
}
</style>
